import React, { useState, useEffect } from "react";
import "./Founder.css";
import { Link } from "react-router-dom";
const Founder = () => {
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <section class="bg">
      <div class="gap top-spac60 ">
        <div class="fixed-bg ptrn-bg"></div>
        <div class="container">
          <div class="sec-title text-center">
            <div class="sec-title-inner">
              <h3>
                {rtl
                  ? "المؤسس والرئيس التنفيذي"
                  : fr
                  ? "Notre fondateur"
                  : "Our Founder"}
              </h3>
              <img
                src={require("../../Assets/pshape.png")}
                alt=""
                class="founder-shape"
              />
            </div>
            <p style={{ width: "70%" }}>
              {rtl
                ? "بصفته المؤسس سيدي شهيد ، يتمتع بخبرة كبيرة في مجال التطوير العقاري والتمويل وتداول السلع ، من بين مساعي أخرى"
                : fr
                ? `En tant que fondateur, Sidi Shahid apporte une
                expérience significative dans le développement
                immobilier, la finance et le commerce des
                matières premières, entre autres activités.`
                : "As Founder Sidi Shahid brings significant experience in real estate development, finance, and commodities trading, among other endeavors."}
            </p>
          </div>
          <div class="team-wrap text-center remove-ext5">
            <div class="row">
              <div style={{ margin: "auto" }}>
                <div class="team-box">
                  <img
                    src={require("../../Assets/sidi.jpg")}
                    alt="team-img1-1.jpg"
                    style={{
                      width: "250px",
                      height: "250px",
                    }}
                  />
                  <div class="team-info">
                    <Link to="/founder">
                      <h4 style={{ marginBottom: "20px" }}>
                        {rtl ? "سيدي شهيد " : fr ? "Fondateur" : "Sidi Shahid"}
                      </h4>
                    </Link>
                    {/* <p>
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipisicing elit, sed do
                                            eiusmod tempor
                                        </p> */}
                    <div class="team-scl">
                      <a href="#" title="Twitter" target="_blank">
                        <i class="fas fa-twitter"></i>
                      </a>
                      <a href="#" title="Linekdin" target="_blank">
                        <i class="fas fa-linkedin"></i>
                      </a>
                      <a href="#" title="Instagram" target="_blank">
                        <i class="fa fa-instagram"></i>
                      </a>
                      <a href="#" title="Facebook" target="_blank">
                        <i class="fa fa-facebook"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
